<template>
  <div class="side-modal" v-if="showModal">
    <div class="side-modal__overlay"></div>

    <div
      class="side-modal__inner"
      :style="{ backgroundColor: color, maxWidth: maxWidth }"
    >
      <div
        class="side-modal__header"
        v-if="!dontViewHeader"
        :style="{ backgroundColor: color }"
      >
        <button
          class="side-modal__close-button cards-icon tooltip-hover"
          @click="$emit('close')"
        >
          <icon name="dowble-arrow-left-icon" />
          <div class="tooltip bot">סגור</div>
        </button>
        <div class="side-modal__block-icon block-icons">
          <!-- <button
            class="side-modal__close-button"
            @click="$emit('delete')"
            v-if="deleteButton"
          >
            <icon name="new-delete-icon" />
          </button> -->

          <div class="mob-block-select">
            <div class="context">
              <button class="close-button" @click="$emit('close')">
                <icon name="dowble-arrow-left-icon" />
              </button>
              <div class="menu-info">
                <ContextMenu
                  v-if="deleteButton"
                  :items="items_context"
                  @selectedContext="item => selectedContext(item)"
                  :icon="'new-delete-icon'"
                ></ContextMenu>

                <ShareLinkVue
                  v-if="shareLink"
                  @createLink="createLink"
                  :lesson_id="event_id"
                  :link="lessonLink"
                ></ShareLinkVue>

                <button
                  v-if="viewHistory"
                  class="sidebar_history-icon"
                  @click="$emit('clickHistory')"
                >
                  <icon name="archive" />
                </button>
                <HistoryMeeting
                  v-if="viewHistory && openHistory"
                  :history="history_lesson"
                  @closeHistory="$emit('closeHistory')"
                ></HistoryMeeting>
              </div>
            </div>
            <div class="likeBlock">
              <div class="select-blocks" v-if="user">
                <StatusSelectMeeting
                  :lessonStatusId="lesson_status"
                  :is_report="is_report"
                  v-if="statusSelectLesson"
                  :latest_meeting_status="latest_meeting_status"
                  class="stasus-select__meeting"
                  @lessonStatus="lessonStatus"
                  @closeLesson="$emit('closeLesson')"
                  @replacmentTeacher="$emit('replacmentTeacher')"
                  @notComplited="$emit('notComplited')"
                  @lesson_status_state="lesson_status_state"
                ></StatusSelectMeeting>
                <div
                  class="absence-reason-block-side"
                  v-if="
                    latest_meeting_status &&
                    latest_meeting_status.cancel_reason &&
                    !changed_status
                  "
                >
                  <div class="select-reason">
                    <CustomThreeSelectVue
                      :multiple="false"
                      :options="cancel_reasons"
                      v-model="not_complited_id"
                      label="למה לא התקיים?"
                    />
                  </div>
                </div>
                <div
                  class="absence-reason-block-side"
                  v-if="
                    latest_meeting_status &&
                    latest_meeting_status.reason_to_replace &&
                    !changed_status
                  "
                >
                  <div class="select-reason">
                    <CustomThreeSelectVue
                      :multiple="false"
                      :options="replacing_teacher"
                      v-model="replacment_id"
                      label="סיבה למורה מחליף"
                    />
                  </div>
                </div>
                <ConfirmDropdown
                  v-if="
                    latest_meeting_status &&
                    latest_meeting_status.meeting_id &&
                    latest_meeting_status.visibility &&
                    latest_meeting_status.visibility.confirm_view &&
                    showConfirm
                  "
                  :lesson_status_id="lesson_id_status_computed"
                  :confirm="confirmed_id_status_computed"
                  :lesson_id="latest_meeting_status.meeting_id"
                  :lesson_status_confirm_fill_user_name="
                    latest_meeting_status.fill_user
                      ? latest_meeting_status.fill_user.name
                      : ''
                  "
                  :lesson_status_confirm_fill_user_last_name="
                    latest_meeting_status.fill_user
                      ? latest_meeting_status.fill_user.last_name
                      : ''
                  "
                  @changeLessonConfirm="changeLessonConfirm"
                />
              </div>
              <AddNewButton
                v-if="!user"
                text="התחברות למערכת"
                size="small"
                @click="gotoLoginPage"
              />
            </div>
          </div>
          <div class="dev-block-select">
            <ContextMenu
              v-if="deleteButton"
              :items="items_context"
              @selectedContext="item => selectedContext(item)"
              :icon="'new-delete-icon'"
            ></ContextMenu>
            <div class="cards-icon tooltip-hover">
              <ShareLinkVue
                v-if="shareLink"
                @createLink="createLink"
                :lesson_id="event_id"
                :link="lessonLink"
              ></ShareLinkVue>
              <div class="tooltip bot">שליחת קישור לדיווח</div>
            </div>
            <div class="select-blocks">
              <div class="status-lesson-block">
                <div class="cards-icon tooltip-hover">
                  <StatusSelectMeeting
                    :lessonStatusId="lesson_status"
                    :latest_meeting_status="latest_meeting_status"
                    v-if="statusSelectLesson"
                    class="stasus-select__meeting"
                    :is_report="is_report"
                    @lessonStatus="lessonStatus"
                    @closeLesson="$emit('closeLesson')"
                    @replacmentTeacher="$emit('replacmentTeacher')"
                    @notComplited="$emit('notComplited')"
                    @checkboxStatusChanged="checkboxStatus"
                    @lesson_status_state="lesson_status_state"
                  ></StatusSelectMeeting>
                  <div class="tooltip bot">סטטוס האירוע</div>
                </div>
                <div
                  class="exel-status"
                  v-if="
                    isCheckboxActive &&
                    latest_meeting_status.visibility &&
                    latest_meeting_status.visibility.received_salary_status_view
                  "
                >
                  <!-- <img src="/images/142.svg" alt="" /> -->
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M4.375 15V6C4.375 5.44772 4.82272 5 5.375 5L8.875 5C10.5319 5 11.875 6.34315 11.875 8V11.25"
                      stroke="#5A6F95"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M8.125 9.375V15H12.625C14.2819 15 15.625 13.6569 15.625 12V5"
                      stroke="#5A6F95"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
              </div>
              <AddNewButton
                v-if="!user"
                text="התחברות למערכת"
                size="small"
                @click="gotoLoginPage"
              />
              <div
                class="absence-reason-block-side"
                v-if="
                  latest_meeting_status &&
                  latest_meeting_status.reason_to_replace &&
                  !changed_status
                "
              >
                <div class="select-reason">
                  <CustomThreeSelectVue
                    :multiple="false"
                    :options="replacing_teacher"
                    v-model="replacment_id"
                    label="סיבה למורה מחליף"
                  />
                </div>
              </div>
              <div
                class="absence-reason-block-side"
                v-if="
                  latest_meeting_status &&
                  latest_meeting_status.cancel_reason &&
                  !changed_status
                "
              >
                <div class="select-reason">
                  <CustomThreeSelectVue
                    :multiple="false"
                    :options="cancel_reasons"
                    v-model="not_complited_id"
                    label="למה לא התקיים?"
                  />
                </div>
              </div>
              <ConfirmDropdown
                v-if="
                  latest_meeting_status &&
                  latest_meeting_status.meeting_id &&
                  latest_meeting_status.visibility &&
                  latest_meeting_status.visibility.confirm_view &&
                  showConfirm
                "
                :lesson_status_id="lesson_id_status_computed"
                :confirm="confirmed_id_status_computed"
                :lesson_id="latest_meeting_status.meeting_id"
                :lesson_status_confirm_fill_user_name="
                  latest_meeting_status.fill_user
                    ? latest_meeting_status.fill_user.name
                    : ''
                "
                :lesson_status_confirm_fill_user_last_name="
                  latest_meeting_status.fill_user
                    ? latest_meeting_status.fill_user.last_name
                    : ''
                "
                @changeLessonConfirm="changeLessonConfirm"
              />
            </div>
            <!-- <ConfirmedStatus
            v-if="statusConfirmView"
            :lessonStatusId="lesson_status"
            :status_confirmed_id="confirmed_id"
            @lessonStatusConfirm="lessonStatusConfirm"
          ></ConfirmedStatus> -->
            <div class="cards-icon tooltip-hover">
              <button
                v-if="viewHistory && history_lesson.length > 0"
                class="sidebar_history-icon"
                @click="$emit('clickHistory')"
              >
                <icon name="archive" />
              </button>
              <div class="tooltip bot only-history">היסטוריה סטטוסים</div>
            </div>
            <HistoryMeeting
              v-if="viewHistory && openHistory && history_lesson.length > 0"
              :history="history_lesson"
              @closeHistory="$emit('closeHistory')"
            ></HistoryMeeting>
          </div>
          <!-- 
          <SelectAcademicYear
            :statusSelect="statusSelect"
            :items="items"
            v-if="isVisibleSelect"
            @selectStatus="selectStatus"
          >
          </SelectAcademicYear> -->
          <StatusSelect
            :statusSelect="statusSelect"
            :items="items"
            v-if="viewStatus"
            @selectStatus="selectStatus"
          ></StatusSelect>

          <div class="header-actions-slot">
            <slot name="header-actions"></slot>
          </div>
        </div>
        <img
          class="side-modal__header__logo"
          v-if="logo"
          :src="'/' + logo"
          alt=""
        />
      </div>
      <div class="side-modal__body">
        <slot></slot>
      </div>
      <!-- pinned bottom bar (e.g. a save button) -->
      <div class="side-modal__footer" v-if="$slots.footer">
        <slot name="footer"></slot>
      </div>
    </div>
    <!-- Generic side panel (e.g. user pickers) — sibling of the inner
         column, same layer the built-in drop-down panels render on. -->
    <slot name="panel"></slot>
    <drop-down-students
      v-if="viewDropDown"
      :dropDownRender="dropDownRender"
      :user_type="user_type_DropDownStudents"
      :filter_groups="filter_groups"
      :filter_classes="filter_classes"
      :institutions="institutions"
      :administration_select="administration_select"
      :departments="departments"
      :id_project="id_project"
      :adm_inst_ids="adm_inst_ids"
      @close="$emit('closeDropDown')"
    ></drop-down-students>
    <DropDownStudentsGroups
      v-if="viewDropStudentGroups"
      :dropDownRender="dropDownRenderStudentsGroups"
      :user_type="
        typeof user_type_DropDownStudentGroups === 'number'
          ? user_type_DropDownStudentGroups
          : user_type_DropDownMembers
      "
      :departments="departments"
      :adm_inst_ids="adm_inst_ids"
      :id_project="id_project"
      :title="'הוספת משתתפים'"
      :is_project="is_project"
      @close="$emit('closeDropDown')"
    ></DropDownStudentsGroups>
    <drop-down-members
      v-if="viewDropDownTwo"
      :dropDownRender="dropDownRenderTwo"
      :filter_groups="filter_groups"
      :filter_classes="filter_classes"
      :institutions="institutions"
      :administration_select="administration_select"
      :user_type="user_type_DropDownMembers"
      :departments="departments"
      :adm_inst_ids="adm_inst_ids"
      :filters="filters"
      :id_project="id_project"
      :adm_ist_ids="adm_ist_ids"
      :title="'הוספת משתתפים'"
      @close="$emit('closeDropDown')"
    ></drop-down-members>
    <drop-down-workers
      v-if="viewDropDownWorkers"
      :dropDownRender="dropDownRenderWorkers"
      :filter_groups="filter_groups"
      :filter_classes="filter_classes"
      :institutions="institutions"
      :administration_select="administration_select"
      :departments="departments"
      :title="'הוספת משתתפים'"
      @close="$emit('closeDropDown')"
    ></drop-down-workers>
    <DropDownComponent
      v-if="viewDropComponent"
      :users_list="users"
      :onlyStudent="onlyStudent"
      :dropDownRender="dropDownRenderComponent"
      :title="'הוספת משתתפים'"
      @close="$emit('closeDropDown')"
      :user_type="user_type_DropDownComponent"
      :filter_groups="filter_groups"
      :filter_classes="filter_classes"
      :institutions="institutions"
      :administration_select="administration_select"
      :departments="departments"
      :viewInstitutionsSelect="viewInstitutionsSelect"
      :group_id="group_id"
      :project_id="project_id"
      :contextInstitutionId="contextInstitutionId"
    ></DropDownComponent>
    <DropDownSoloSelect
      v-if="viewSoloDrop"
      :users_list="workers"
      :dropDownRender="dropDownRenderSolo"
      :title="'הוספת משתתפים'"
      @close="$emit('closeDropDown')"
    ></DropDownSoloSelect>
    <DropDownWorkerList
      v-if="viewWorkerList"
      @serched="serchedWorkerList"
      :users_list="workers"
      :dropDownRender="dropDownRenderWorkerList"
      :title="'הוספת משתתפים'"
      @close="$emit('closeDropDown')"
    >
    </DropDownWorkerList>
    <DropDownReplacementSolo
      v-if="viewRepDrop"
      :users_list="replacment_users"
      :dropDownRender="dropDownRepSolo"
      :title="'הוספת משתתפים'"
      @close="$emit('closeDropDown')"
    ></DropDownReplacementSolo>
  </div>
</template>

<script>
import Icon from '@/Components/UI/Icon';
import StatusSelect from '../../Common/StatusSelect.vue';
import AddNewButton from '@/Components/UI/Buttons/BlueButton.vue';

import DropDownStudents from '@/Components/UI/DropDowns/DropDownStudents.vue';
import DropDownMembers from '@/Components/UI/DropDowns/DropDownMembers.vue';
import DropDownWorkers from '../DropDowns/DropDownWorkers.vue';
import DropDownComponent from '../DropDowns/DropDownComponent.vue';
import DropDownSoloSelect from '../DropDowns/DropDownSoloSelect.vue';
import DropDownWorkerList from '../DropDowns/DropDownWorkerList.vue';
import DropDownStudentsGroups from '../DropDowns/DropDownStudentsGroups.vue';

import DropDownReplacementSolo from '../DropDowns/DropDownReplacementSolo.vue';
import ShareLinkVue from '../../Share/ShareLink.vue';
import StatusSelectMeeting from '@/Components/UI/Form/StatusSelectMeeting.vue';
import ConfirmedStatus from '../Buttons/ConfirmedStatus.vue';
import HistoryMeeting from '@/Components/Modals/HistoryMeeting.vue';
import ContextMenu from '../../Common/ContextMenu.vue';
import SelectAcademicYear from '../Form/SelectAcademicYear.vue';
import ConfirmDropdown from '@/Components/UI/Form/ConfirmDropDownMeeting.vue';
import CustomThreeSelectVue from '@/Components/UI/Form/CustomThreeSelect.vue';
import { mapGetters } from 'vuex';

// import NewButton from '@/Components/UI/Buttons/NewButton.vue';
export default {
  components: {
    ContextMenu,
    CustomThreeSelectVue,
    ShareLinkVue,
    DropDownWorkerList,
    AddNewButton,
    StatusSelectMeeting,
    DropDownStudentsGroups,
    // ConfirmedStatus,
    ConfirmDropdown,
    Icon,
    StatusSelect,
    DropDownReplacementSolo,
    DropDownStudents,
    DropDownMembers,
    DropDownComponent,
    DropDownSoloSelect,
    DropDownWorkers,
    HistoryMeeting
    // SelectAcademicYear
    // NewButton
    // DropDownMembers
  },
  props: {
    dropDownRenderStudentsGroups: {
      type: Boolean,
      default: false
    },
    is_project: {
      type: Boolean,
      default: false
    },
    viewDropStudentGroups: {
      type: Boolean,
      default: false
    },
    filters: {
      type: [],
      default: () => []
    },
    adm_ist_ids: {
      type: []
    },
    is_report: {
      type: Boolean,
      default: false
    },
    showConfirm: {
      type: Boolean,
      default: true
    },
    viewInstitutionsSelect: {
      type: Boolean,
      default: false
    },
    cancel_reasons: {
      type: []
    },
    replacing_teacher: {
      type: []
    },
    id_project: {
      type: [Number, String],
      default: ''
    },
    replacment_users: Array,
    group_id: {
      type: [Number, String],
      default: ''
    },
    project_id: {
      type: [Number, String],
      default: ''
    },
    adm_inst_ids: {
      type: Array
    },
    user_type_DropDownMembers: {
      type: Number
    },
    user_type_DropDownStudentGroups: {
      type: Number
    },
    user_type_DropDownComponent: {
      type: Number
    },
    user_type_DropDownStudents: {
      type: Number
    },
    items_context: {
      type: Array
    },
    viewWorkerList: {
      type: Boolean,
      default: false
    },
    deleteButton: Boolean,
    administration_select: Array,
    filter_classes: Array,
    filter_groups: Array,
    institutions: Array,
    departments: Array,
    onlyStudent: Boolean,
    contextInstitutionId: {
      type: [Number, String],
      default: null
    },
    history_lesson: {
      type: Array
    },
    viewHistory: {
      type: Boolean,
      default: false
    },
    openHistory: {
      type: Boolean,
      default: false
    },
    latest_meeting_status: {
      type: Object
    },
    confirmed_id: {
      type: [Number, String]
    },
    statusConfirmView: {
      type: Boolean,
      default: false
    },
    lessonLink: {
      type: [Number, String]
    },
    maxWidth: {
      type: String,
      default: () => '692px'
    },
    event_id: {
      type: [Number, String]
    },
    changed_status: {
      type: [Number, String]
    },
    event: {
      type: Object
    },
    lesson_status: {
      type: [Number, String]
    },
    statusSelectLesson: {
      type: Boolean,
      default: false
    },
    shareLink: {
      type: Boolean,
      default: false
    },
    users: {
      type: Array
    },
    dropDownRenderSolo: {
      type: Boolean,
      default: false
    },
    dropDownRepSolo: {
      type: Boolean,
      default: false
    },
    viewRepDrop: {
      type: Boolean,
      default: false
    },
    workers: {
      type: Array
    },
    color: {
      type: String,
      default: '#ffffff'
    },
    viewSoloDrop: {
      type: Boolean,
      default: false
    },
    dropDownRender: {
      type: Boolean,
      default: false
    },
    dropDownRenderComponent: {
      type: Boolean,
      default: false
    },
    dropDownRenderWorkers: {
      type: Boolean,
      default: false
    },
    dropDownRenderTwo: {
      type: Boolean,
      default: false
    },
    dropDownRenderWorkerList: {
      type: Boolean,
      default: false
    },
    selected_users: {
      type: Array
    },
    selected_users_two: {
      type: Array,
      default: () => []
    },
    statusSelect: {
      type: Object
    },
    showModal: {
      type: Boolean
    },
    items: {
      type: Array
    },
    logo: {
      type: String
    },
    dontViewHeader: {
      type: Boolean,
      default: false
    },
    viewStatus: {
      type: Boolean,
      default: false
    },
    viewDropDown: {
      type: Boolean,
      default: false
    },
    viewDropComponent: {
      type: Boolean,
      default: false
    },
    viewDropDownWorkers: {
      type: Boolean,
      default: false
    },
    viewDropDownTwo: {
      type: Boolean,
      default: false
    },
    isVisibleSelect: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      replacment_id:
        this.latest_meeting_status &&
        this.latest_meeting_status.reason_to_replace
          ? this.latest_meeting_status.reason_to_replace.id
          : null,
      lesson_status_state_id: null,
      not_complited_id:
        this.latest_meeting_status && this.latest_meeting_status.cancel_reason
          ? this.latest_meeting_status.cancel_reason.id
          : null,
      isCheckboxActive:
        this.latest_meeting_status &&
        this.latest_meeting_status.received_salary_status == 1
          ? true
          : false
    };
  },
  computed: {
    ...mapGetters({
      user: 'auth/user'
    }),
    lesson_id_status_computed() {
      if (this.lesson_status_state_id) {
        console.log(
          this.latest_meeting_status.status,
          'this.latest_meeting_status.status if'
        );

        return this.lesson_status_state_id;
      } else {
        console.log(
          this.latest_meeting_status.status,
          'this.latest_meeting_status.status'
        );
        return this.latest_meeting_status.status;
      }
    },
    confirmed_id_status_computed() {
      if (this.lesson_status_state_id) {
        return 3;
      } else {
        return this.latest_meeting_status.confirmed;
      }
    }
  },
  watch: {
    latest_meeting_status: {
      handler(newVal, oldVal) {
        if (newVal.cancel_reason) {
          this.not_complited_id = newVal.cancel_reason.id;
        }
        if (newVal.reason_to_replace) {
          this.replacment_id = newVal.reason_to_replace.id;
        }
        console.log('Объект изменился', newVal);
        // Здесь можно выполнять действия, когда изменяется любой вложенный элемент объекта
      },
      deep: true
    },

    lesson_status(val) {
      console.log('lesson_status watch', val);
    },
    replacment_id(val) {
      this.$emit('replacment_id_changed', val);
    },
    not_complited_id(val) {
      this.$emit('not_complited_id_changed', val);
    }
  },
  methods: {
    gotoLoginPage() {
      const currentPath = this.$route.path;
      sessionStorage.setItem('currentPath', currentPath);
      this.$router.push('/sign-in');
    },
    lesson_status_state(id) {
      this.lesson_status_state_id = id;
    },
    checkboxStatus(isChecked) {
      this.isCheckboxActive = isChecked;
      this.$emit('lessonUpdateSalary', isChecked);
    },
    serchedWorkerList(val) {
      this.$emit('serchedWorkerList', val);
    },
    changeLessonConfirm(confirm, lessonID) {
      this.$emit('changeLessonConfirm', confirm, lessonID);
    },
    selectedContext(item, per) {
      this.$emit('selectedContext', item, per);
    },
    lessonStatusConfirm(item) {
      this.$emit('lessonStatusConfirm', item);
    },
    lessonStatus(item) {
      this.$emit('changeStatus', item);
    },
    createLink() {
      this.$emit('createLink');
    },
    selectUsersModal(val) {
      this.$emit('selectUsersModal', val);
    },

    selectStatus(status) {
      this.$emit('selectStatus', status);
    }
  }
};
</script>

<style lang="scss" scoped>
.only-history {
  width: 58px;
  white-space: normal !important;
  text-align: right;
}
.cards-icon {
  position: relative;
}
.absence-reason-block-side {
  max-width: 250px;
}
.status-lesson-block {
  display: flex;
  align-items: baseline;
  gap: 4px;
  padding-left: 4px;
  // background: #f2f4f7;
  border-radius: 12px;
}
.close-button {
  border: none;
  background-color: transparent;
  cursor: pointer;
  display: flex;
  align-items: center;
  width: 24px;
  height: 24px;
  stroke: #5a6f95;
}
.select-blocks {
  display: flex;
  gap: 8px;
  align-items: center;
}
.dev-block-select {
  display: flex;
  gap: 8px;
  align-items: center;
}
.sidebar_history-icon {
  border: none;
  background: none;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  stroke: #38455d;
  color: #38455d;

  ::v-deep svg,
  ::v-deep path {
    stroke: #38455d;
  }
}
.stasus-select__meeting {
  min-width: 130px;
}
.side-modal__block-icon {
  display: flex;
  align-items: center;
  gap: 8px;
}
.header-actions-slot {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  flex-shrink: 1;
  overflow: visible;
}
.header-actions-slot:empty {
  display: none;
}
.side-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100dvh;
  z-index: 101;
  &__overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.8);
    backdrop-filter: blur(2px);
  }
  &__header {
    position: sticky;
    top: 0;
    left: 0;
    width: 100%;
    background-color: #fff;
    border-bottom: 1px solid #e3e7ee;
    padding: 6px 16px;
    min-height: 52px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    // above the body's own layers (selects, cards…) — they scrolled over it
    z-index: 20;
    overflow: visible;
    &__logo {
      max-width: 24px;
      max-height: 24px;
    }
  }
  &__close-button {
    border: none;
    background-color: transparent;
    cursor: pointer;
    display: flex;
    align-items: center;
    width: 24px;
    height: 24px;
    stroke: #5a6f95;
  }
  &__inner {
    position: absolute;
    z-index: 1;
    top: 0;
    left: 0;
    height: 100dvh;
    width: 100%;
    box-shadow: 0px 8px 20px -4px rgba(56, 69, 93, 0.08),
      0px 4px 12px -4px rgba(56, 69, 93, 0.04);
    border-right: 1px solid #e3e7ee;
    background: #ffffff;
    overflow-y: auto;
    overflow-x: clip;
    @media (max-width: 1024px) {
      max-width: 486px !important;
    }
    @media (max-width: 767px) {
      max-width: 100%;
    }
  }
  &__body {
    padding: 16px 16px 84px;
  }

  &__footer {
    background-color: #fff;
    padding: 16px;
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    max-width: 692px;
    z-index: 9;
    @media (max-width: 1024px) {
      max-width: 486px;
    }
    @media (max-width: 767px) {
      max-width: 100%;
    }
  }
}

@media (max-width: 490px) {
  .dev-block-select {
    display: none;
  }
  .side-modal__close-button {
    display: none;
  }
  .side-modal__header {
    padding: 10px 10px 6px;
    overflow: visible;
  }
  .block-icons {
    width: 100%;
    flex-wrap: nowrap;
    align-items: center;
    gap: 4px;
    min-width: 0;
    overflow: visible;
  }
  // close button stays on the right, all other actions go to the left
  .mob-block-select {
    width: auto;
    flex: 1 1 auto;
    min-width: 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 4px;
  }
  .header-actions-slot {
    flex: 0 1 auto;
    min-width: 0;
    justify-content: flex-end;
    overflow: visible;
    gap: 4px;
  }
  .context {
    flex: 1 1 auto;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 4px;
  }
  .menu-info {
    margin-inline-start: auto;
    display: flex;
    align-items: center;
    gap: 4px;
  }
}

@media (min-width: 490px) {
  .mob-block-select {
    display: none;
  }
}
</style>
